import { Link, useSearchParams } from "react-router-dom";
import { waLink } from "@/lib/config";
import { CheckCircle2 } from "lucide-react";

export default function CustomTripSuccessPage() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const email = params.get("email");

  return (
    <div data-testid="custom-trip-success-page" className="pt-36 md:pt-40 pb-24 min-h-[80vh] bg-[#FAF6F0]">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-[#A6521B]/12 text-[#A6521B] rounded-full mb-8">
          <CheckCircle2 size={40} />
        </div>
        <p className="overline">karibu sana</p>
        <h1 className="font-display text-5xl md:text-7xl italic font-light mt-4 leading-tight">Request Received.</h1>

        {ref && (
          <div className="mt-10 bg-[#FFFFFF] border border-[#E2D5C3] rounded-3xl shadow-[0_4px_20px_-2px_rgba(35,23,14,0.06)] p-8 md:p-10">
            <p className="overline">your lead reference</p>
            <p className="font-marcellus text-4xl text-[#A6521B] mt-2">{ref}</p>
          </div>
        )}

        <p className="mt-10 text-[#23170E]/70 leading-relaxed max-w-xl mx-auto">
          {email && <>We've emailed a confirmation to <strong>{email}</strong>.</>} One of our trip designers will
          reach out within 24 hours with two or three tailored itinerary ideas — all handcrafted, none templated.
        </p>

        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link to="/tours" data-testid="cts-explore" className="btn-pill btn-pill-outline">
            Browse Ready-Made Tours
          </Link>
          <a
            href={waLink(
              ref
                ? `Hi APEX, I just submitted custom trip request ${ref}. I'd love to talk through my Tanzania itinerary.`
                : "Hi APEX, I just submitted a custom trip request on your website."
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="cts-whatsapp"
            className="btn-pill bg-[#25D366] text-white hover:bg-[#1ebd5b]"
          >
            Message Us on WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
